import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Status, Ticket } from '../../types/services.type';
import ApplicationDetails from './components/applicationDetails';
import StatusDetails from './components/statusDetails';
import ComplaintStatus from './components/complaintStatus';
import EsclateIssueButton from './components/esclateIssueButton';
import TrackStatus from './trackStatus';
import { getProductImageByName } from '../../helpers/imageHelpers';
import ActivityIndicator from '../../components/activityIndicator';
import TrackStatusService from '../../services/getStatus.service';
import { useSelector } from 'react-redux';
import { Stack } from '@mui/material';
import HeadingWithDescription from '../../components/headingWithDescription';
import { RootState } from '../../store/store';

// function AssignedTechnician({
//   imageUrl,
//   ticketNumber,
// }: {
//   imageUrl: string;
//   ticketNumber: string;
// }) {
//   const navigate = useNavigate();
//   return (
//     <Stack
//       flexDirection={'row'}
//       sx={{
//         borderWidth: 1,
//         borderRadius: 1,
//         justifyContent: 'space-between',
//         alignContent: 'center',
//         gap: 1,
//         p: 1,
//       }}
//     >
//       <Stack>
//         {imageUrl && (
//           <img
//             alt="technician-img"
//             src={imageUrl}
//             style={{
//               height: 60,
//               width: 60,
//               borderRadius: 50,
//               objectFit: 'cover',
//               borderWidth: 2,
//             }}
//           />
//         )}
//         <Stack
//           flexDirection={'row'}
//           alignItems={'center'}
//           bgcolor={'white'}
//           sx={{
//             borderWidth: 1,
//             justifyContent: 'center',
//             gap: 0.5,
//             alignSelf: 'center',
//             px: 1,
//             mt: -2,
//             borderRadius: 12,
//           }}
//         >
//           <Star sx={{ fontSize: 12 }} />
//           <Typography sx={{ fontSize: 12 }}>4.5</Typography>
//         </Stack>
//       </Stack>

//       <Stack flex={1} justifyContent={'center'}>
//         <Typography fontWeight={'bold'}>Rishabh Verma</Typography>
//         <Typography variant="caption">Technician</Typography>
//       </Stack>
//       <Stack alignItems={'center'} flexDirection="row">
//         <Button size='small'>
//           <IoMdCall fontSize={30} />
//         </Button>
//         <Button size='small' variant="text" onClick={() => navigate('/track-status/chat?id=' + ticketNumber)}>
//           <IoChatbubble size={30} />
//         </Button>
//       </Stack>
//     </Stack>
//   );
// }

const TrackStatusSingle: React.FC<any> = ({ route, navigation }) => {
  const [statusDetails, setStatusDetails] = useState<Ticket | null>(null);
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const ticketNumber = searchParams.get('id');
  const { token, userId } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (ticketNumber && token) {
      TrackStatusService.getStatusDetailsByTicketNoAsync(ticketNumber, token, userId).then(
        (data: Ticket | null) => {
          if (!data) return navigate('/');
          setStatusDetails(data);
          setLoading(false);
        },
      );
    }

    return () => {
      setStatusDetails(null);
    };

    // eslint-disable-next-line
  }, [ticketNumber]);

  if (!ticketNumber) return <TrackStatus />;

  return (
    <div className="flex flex-col container mx-auto flex-1">
      <Stack p={2}>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={1}>
          <HeadingWithDescription heading="" description={ticketNumber} />
        </Stack>
      </Stack>
      {loading && <ActivityIndicator />}
      {statusDetails && (
        <div className="flex-1 flex flex-col gap-6  p-3">
          <ApplicationDetails
            title={statusDetails?.product}
            machineStatus={statusDetails?.machineStatus}
            image_url={
              statusDetails?.prd_image_url ?? getProductImageByName(statusDetails?.product)
            }
            model={statusDetails?.model}
            status={statusDetails.status}
          />
          <StatusDetails
            status={statusDetails.status}
            serialNo={statusDetails?.serialNo}
            complaintNo={statusDetails.ticketNo}
            requestType={statusDetails?.callType}
            reportedOn={statusDetails.callBookDate}
          />
          {/* <AssignedTechnician imageUrl={imageUrl} ticketNumber={ticketNumber} /> */}
          {statusDetails?.status !== Status.Closed &&
            statusDetails?.status !== Status.Cancelled &&
            statusDetails?.status !== Status.Resolved && (
              <EsclateIssueButton ticket={statusDetails} reportedOn={statusDetails?.callBookDate} />
            )}
          {statusDetails?.statusHistory?.length > 0 && (
            <ComplaintStatus statusHistory={statusDetails?.statusHistory ?? []} />
          )}
        </div>
      )}
    </div>
  );
};

export default TrackStatusSingle;
